/**
 * Offer room data fetching hook
 * Extracted from original lines 142-152
 */

import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import useOfferRoom from "../../../hooks/useOfferRoom";
import { InvestmentOpportunity } from "../StructureNote.types";

/**
 * Hook to fetch and manage offer room investment opportunities
 * Original logic from lines 142-152
 *
 * @param token - Authentication token
 * @returns Offer room data, loading state, and refetch function
 */
export const useOfferRoomData = (token: string) => {
  const [offerRoomData, setOfferRoomData] = useState<InvestmentOpportunity[]>([]);
  const offerRoomMutation = useOfferRoom();

  useEffect(() => {
    offerRoomMutation.mutate(
      { token },
      {
        onSuccess: (data) => {
          setOfferRoomData(data);
        },
        onError: (error: any) => {
          toast.error(error);
        },
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return {
    offerRoomData,
    isLoading: offerRoomMutation.isLoading,
    refetch: () => offerRoomMutation.mutate({ token }),
  };
};
